import React, { useEffect } from "react";
import { Layout, Grid } from "antd";
import { connect } from "react-redux";
import TopNav from "components/layout-components/TopNav";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import Footer from "components/layout-components/Footer";
import navigationConfig from "configs/NavigationConfig";
import {
	SIDE_NAV_WIDTH,
	SIDE_NAV_COLLAPSED_WIDTH,
	NAV_TYPE_SIDE,
	NAV_TYPE_TOP,
} from "constants/ThemeConstant";
import utils from "utils";
import PaymentViews from "views/payment-views";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const PaymentLayout = ({
  navCollapsed,
	navType,
	location,
}) => {
  const currentRouteInfo = utils.getRouteInfo(
		navigationConfig,
		location.pathname
	);
  const screens = utils.getBreakPoint(useBreakpoint());
	const isMobile = !screens.includes("lg");
	const isNavSide = navType === NAV_TYPE_SIDE;
	const isNavTop = navType === NAV_TYPE_TOP;
	const getLayoutGutter = () => {
		if (isNavTop || isMobile) {
			return 0;
		}
		return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
	};
  useEffect(() => {}, []);
  return (
    <Layout>
    <HeaderNav isMobile={isMobile} headerNavExpand={false} />
    {isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
    <Layout className="app-container">
        <div className={`app-content ${isNavTop ? "layout-top-nav" : ""}`}>
          <Content>
            <PaymentViews />
          </Content>
        </div>
        <Footer />
    </Layout>
    {isMobile && <MobileNav />}
  </Layout>
  );
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, navType, locale } = theme;
	return { navCollapsed, navType, locale };
};

const mapDispatchToProps = {
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(React.memo(PaymentLayout));
